import { date, showAlert } from '../../../lib/helpers';
import {headers, search, dataDelayServiceHit } from './attributes';


export default {
  data: () => ({
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    headers,
    search,
    selectedRow: '',
    bdateFormatted: '',
    dateMenuBDate: false,
    cdateFormatted: '',
    dateMenuCDate: false,
    searchActiveUser: '',
    dialogConfirmation: false,
    selectedId: null,
    delayHitService: null,
  }),

  computed: {
    flashErrorMessage() {
      return this.$store.state.broadcast.broadcastEmail.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.broadcast.broadcastEmail.flashError;
      },
      set() {
        this.$store.commit('broadcast/broadcastEmail/setFlashErrorMessage', '');
      },
    },
    loadingActiveUser() {
      return this.$store.state.users.loadingActiveUser;
    },
    itemsActiveUser() {
      return this.$store.state.users.allActiveUser;
    },
    errorValidation() {
      return this.$store.state.broadcast.broadcastEmail.errors;
    },
    loading() {
      return this.$store.state.broadcast.broadcastEmail.loading;
    },
    merchants() {
      return this.$store.state.broadcast.broadcastEmail.allMerchants;
    },
    totalPage() {
      return this.$store.state.broadcast.broadcastEmail.totalPage;
    },
    totalMerchants() {
      return this.$store.state.broadcast.broadcastEmail.totalMerchants;
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    'search.created_at': {
      handler() {
        this.cdateFormatted = this.formatDate(this.search.created_at);
        this.getData();
      },
    },
    'search.broadcast_date': {
      handler() {
        this.bdateFormatted = this.formatDate(this.search.broadcast_date);
        this.getData();
      },
    },
    searchActiveUser: {
      handler() {
        clearTimeout(this.delayHitService);
        this.delayHitService = setTimeout(() => {
          this.getActiveUser();
        }, dataDelayServiceHit);
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
  methods: {
    clearFilterData(field) {
      this.search[field] = ''; 
      this.getData(); 
    },
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.subject = '';
      this.search.created_at = '';
      this.search.email = '';
      this.search.broadcast_date = '';
      this.search.created_by = '';
      this.getData();
    },

    openDialogConfirmation(id) {
      if (id != null) {
        this.selectedId = id;
        this.dialogConfirmation = true;
      } else {
        this.selectedId = null;
        this.dialogConfirmation = false;
      }
    },
    searchFilter(){
      this.options.page = 1;
      this.getData();
    },
    getData() {
      this.$store.commit('broadcast/broadcastEmail/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('broadcast/broadcastEmail/fetchDataHistory', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    getActiveUser() {
      this.$store.dispatch('users/getActiveUser', {
        date,
        userID: this.searchActiveUser,
        all: true,
      });
    },

    deleteHistory() {
      this.$store
        .dispatch('broadcast/broadcastEmail/deleteBroadcast', {
          date,
          id: this.selectedId,
        })
        .then((response) => {
          if (response) {
            showAlert(
              this.$store,
              'Delete Broadcast success !',
              'mdi-check-circle',
              'green'
            );
            this.getData();
          } else {
            showAlert(
              this.$store,
              'Failed Delete broadcast !',
              'mdi-alert',
              'red'
            );
          }
        })
        .finally(() => {
          this.openDialogConfirmation(null);
        });
    },

    closeFlash() {
      this.$store.commit('broadcast/broadcastEmail/setFlashErrorMessage', '');
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
  },
};